import { PublicClientApplication } from '@azure/msal-browser';
import { AccessToken } from 'buzz_lib_ui';
export const createMsalAuthClient = authConfig => {
  const redirectUri = window.location.port ? "".concat(window.location.protocol, "//").concat(window.location.hostname, ":").concat(window.location.port) : "".concat(window.location.protocol, "//").concat(window.location.hostname);
  return new PublicClientApplication({
    auth: {
      clientId: authConfig.clientId,
      authority: authConfig.authority,
      knownAuthorities: authConfig.knownAuthorities,
      redirectUri: redirectUri
    },
    cache: {
      cacheLocation: 'localStorage'
    },
    system: {
      tokenRenewalOffsetSeconds: AccessToken.RENEWAL_OFFSET_SECONDS
    }
  });
};